import { FileItem, FileUploadService, FileUploadServiceProvider } from '@playbooks/action-cards-utils'
import { Section } from '@playbooks/core/src/interfaces/ActionCard'

import useFomService from '../hooks/useFomService'
import { useAppContext } from '../contexts/AppContext'

export class ProjectFileUploadServiceProvider implements FileUploadServiceProvider {
  public getService(): FileUploadService {
    const {
      settings: { playId },
      // getService is called inside a React component, so we can use hooks here
      // Merged PR 2830: User Story 10647: Make File Upload available on a WebPlay
      // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useAppContext()
    return new ProjectFileUploadService(playId || '')
  }
}

class ProjectFileUploadService implements FileUploadService {
  // ProjectFileUploadService is used inside a React component, so we can use hooks here
  // Merged PR 2830: User Story 10647: Make File Upload available on a WebPlay
  // eslint-disable-next-line react-hooks/rules-of-hooks
  private fomService = useFomService()

  private projectId?: number | string

  public get isDisabled() {
    return !this.projectId
  }

  constructor(projectId?: number | string) {
    this.projectId = projectId
  }

  public async deleteFile(file: FileItem): Promise<void> {
    await this.fomService.deleteProjectFile(file.id)
  }

  public async uploadFiles(uploadingFiles: File[], currentHeader: Section): Promise<FileItem[]> {
    const uploadPromises = []
    const newFileItems: FileItem[] = []
    for (let i = 0; i < uploadingFiles.length; i++) {
      const file = uploadingFiles[i]
      uploadPromises.push(
        this.fomService
          .uploadProjectFile(this.projectId!, currentHeader.id, currentHeader.name, file)
          .then(([id, url]) => {
            newFileItems.push({ id, name: file.name, url })
          })
          .catch(error => {
            newFileItems.push({ id: 0, name: file.name, error: error.message })
          }),
      )
    }

    await Promise.all(uploadPromises)
    return newFileItems
  }
}
